import keyBy from 'lodash/keyBy';
import subDays from 'date-fns/subDays';
import { getFormattedDateFns } from 'shared/helpers/locale';

import { EVENT_TYPES, OBJECT_TYPES } from '../constants/stats';
import API from '../constants/api';

export const fetchStats = (fetch, identifiers, isSpare = false) =>
  fetch(
    API.STATS.AGGS(
      identifiers,
      getFormattedDateFns(subDays(new Date(), 30), 'yyyy-MM-dd'),
      isSpare ? [OBJECT_TYPES.SPARE_PART] : [OBJECT_TYPES.ADVERT],
    ),
  )
    .then(response => {
      if (!response.ok) {
        throw new Error('Не удалось загрузить статистику');
      }

      return response;
    })
    .then(r => r.json())
    .then(stats =>
      stats.map(({ id, dates }) => ({
        id,
        phoneViews: dates
          .map(
            ({ object_types: objectTypes }) =>
              (
                objectTypes
                  .find(type =>
                    type.object_type === isSpare ? OBJECT_TYPES.SPARE_PART : OBJECT_TYPES.ADVERT,
                  )
                  .events.find(event => event.event === EVENT_TYPES.PHONE_CLICK) || {}
              ).count,
          )
          .reduce((sum, count) => sum + (count || 0), 0),
        dates: keyBy(
          dates.map(({ date, object_types: objectTypes }) => ({
            date,
            count: (
              objectTypes
                .find(type =>
                  type.object_type === isSpare ? OBJECT_TYPES.SPARE_PART : OBJECT_TYPES.ADVERT,
                )
                .events.find(event => event.event === EVENT_TYPES.VIEW) || {}
            ).count,
          })),
          obj => obj.date,
        ),
      })),
    );



// WEBPACK FOOTER //
// ./src/shared/helpers/stats.js